import React, { Component } from 'react';

import Chart from '../common/chartWithoutDates';

module.exports = React.createClass({
    render: function () {
        var Data = {
            userID: this.props.patientID
        };


        return (
            <div>
                <h3 className="padding30">Measurements Summary</h3>
                <ul className="nav nav-tabs padding30">
                    <li className="active">
                        <a href="#Humidity" data-toggle="tab">Hydration</a>
                    </li>
                    <li>
                        <a href="#SebumForhead" data-toggle="tab">Sebum Forehead</a>
                    </li>
                    <li>
                        <a href="#SebumRightCheek" data-toggle="tab">Sebum Right Cheek</a>
                    </li>
                    <li>
                        <a href="#Elasticity" data-toggle="tab">Elasticity</a>
                    </li>
                </ul>

                <div className="tab-content clearfix">
                    <div className="tab-pane active" id="Humidity">
                        <MeasurmentsData MeasurmentType="Hydration" ChartAjaxUrl="/data/GetUserHumidityAverage" Data={Data} ChartID="humidityChart" ChartContainer="humidityChartContainer" />
                    </div>
                    <div className="tab-pane" id="SebumForhead">
                        <MeasurmentsData MeasurmentType="Sebum Forehead" ChartAjaxUrl="/data/GetUserSebumForheadAverage" Data={Data} ChartID="sebumChartFH" ChartContainer="sebumChartContainerFH" />
                    </div>
                    <div className="tab-pane" id="SebumRightCheek">
                        <MeasurmentsData MeasurmentType="Sebum Right Cheek" ChartAjaxUrl="/data/GetUserSebumRightCheekAverage" Data={Data} ChartID="sebumChartRC" ChartContainer="sebumChartContainerRC" />
                    </div>
                    <div className="tab-pane" id="Elasticity">
                        <MeasurmentsData MeasurmentType="Elasticity" ChartAjaxUrl="/data/GetUserElasticityAverage" Data={Data} ChartID="elasticityChart" ChartContainer="elasticityChartContainer" />
                    </div>
                </div>

            </div>
        )
    }
});


class MeasurmentsData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedDate: '',
            avgResult: ''
        }
    }

    chartClick(activePoints, chartData) {
        var userPoint = activePoints[0];
        var defaultPoint = activePoints[1];

        if (userPoint) {
            var date = chartData.dates[userPoint._index];
            var userData = chartData.datasets[0].data[userPoint._index];

            this.setState({
                checkedDate: date,
                avgResult: userData
            });
        }
    }

    loadData(chartData) {
        var last = chartData.dates.length-1;

        var date = chartData.dates[last];
        var userData = chartData.datasets[0].data[last];
        this.setState({
            checkedDate: date,
            avgResult: userData
        });
    }

    render() {
        var Data = this.props.Data;
        return (
            <div className='MeasurmentSummaryPanel'>
                <div className='float-left'>
                    <span className='date'>{this.state.checkedDate}</span>
                    <h4>Avg. {this.props.MeasurmentType} Result: <span className='avgResult'>{this.state.avgResult}</span></h4>

                </div>

                <div className='float-right'>
                    <Chart
                        ChartAjaxUrl={this.props.ChartAjaxUrl}
                        Data={Data}
                        ChartType="line"
                        ID={this.props.ChartID}
                        OnClick={this.chartClick.bind(this)}
                        OnLoadData={this.loadData.bind(this)}
                        containerId={this.props.ChartContainer} />
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./modules/patientSummary/Measurements.jsx